import clone from 'lodash/clone';
import { getCurrencyPrecision, shouldCommafy } from '../../utility/k_currency';
import {
    IUpgradeTokenResponse,
    ITokenResponse,
    IProfileActivityRes,
    ICustomerActivity,
    IProfileActivityView,
    IMiniRestaurant,
    IMiniRestaurantView,
} from './type';

export const transformUpgradeTokenResponse = (data: IUpgradeTokenResponse): ITokenResponse => {
    const auth: ITokenResponse = {
        JWTToken: data.access || data.JWTToken,
        refresh: data.refresh,
        isAuthorized: true,
        profile: data.profile,
    };

    return auth;
};

const getCurrencyFormat = (restaurant: IMiniRestaurant) => ({
    cs: restaurant.currencySymbol,
    cc: restaurant.currency,
    currencyPrecision: getCurrencyPrecision(restaurant.currency),
    currencyCommaSeparator: shouldCommafy(restaurant.currency) ? ('enable' as const) : ('disable' as const),
});

const findMatchingRestaurant = (restaurants: IMiniRestaurantView[], restaurantUnique: string) =>
    restaurants.find((restaurant) => restaurant.unique === restaurantUnique);

export const transformActivityResponse = (data: IProfileActivityRes): IProfileActivityView => {
    const transformable: IProfileActivityView = clone(data) as IProfileActivityView;

    transformable._restaurants = transformable.restaurants.map((restaurant) => ({
        ...restaurant,
        currencyFormat: getCurrencyFormat(restaurant),
    }));

    transformable._activities = transformable.activities.map((activity: ICustomerActivity) => ({
        ...activity,
        createdAt: activity.createdAt * 1000,
        _restaurant: findMatchingRestaurant(transformable._restaurants, activity?.data?.restaurantUnique)!,
    }));

    return transformable;
};
